import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Typography } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './BillingSection.module.scss';
export const GetBillingSectionTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const BillingSection = (param)=>{
    let { title, subtitle, services, hasOptionalServices, isOptional, testId } = param;
    const { BillingSectionTestIds } = useMemo(()=>GetBillingSectionTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        className: styles.billingSection,
        testId: BillingSectionTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                className: styles.header,
                children: [
                    hasOptionalServices && !isOptional && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "secondary",
                        testId: BillingSectionTestIds.StartsAtText(),
                        children: "Starts at"
                    }),
                    title && /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        testId: BillingSectionTestIds.Title(),
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        testId: BillingSectionTestIds.Subtitle(),
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.servicesList,
                "data-testid": BillingSectionTestIds.ServicesList(),
                children: services.map((service)=>{
                    const showCheckmark = !isOptional || service.includedByDefault;
                    return /*#__PURE__*/ _jsxs("li", {
                        className: styles.serviceItem,
                        "data-testid": BillingSectionTestIds.ServiceItem(service.id),
                        children: [
                            showCheckmark ? /*#__PURE__*/ _jsx(Checkmark, {
                                className: styles.checkIcon,
                                testId: BillingSectionTestIds.ServiceCheckmark(service.id)
                            }) : /*#__PURE__*/ _jsx("span", {
                                className: styles.checkIconPlaceholder
                            }),
                            /*#__PURE__*/ _jsxs(Column, {
                                className: styles.serviceContent,
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph2",
                                        children: service.name
                                    }),
                                    service.includedServices && service.includedServices.length > 0 && /*#__PURE__*/ _jsx("ul", {
                                        className: styles.includedServicesList,
                                        children: service.includedServices.map((included)=>/*#__PURE__*/ _jsx("li", {
                                                "data-testid": BillingSectionTestIds.IncludedServiceItem(included.name),
                                                children: /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "paragraph2",
                                                    skin: "secondary",
                                                    children: included.name
                                                })
                                            }, included.name))
                                    })
                                ]
                            })
                        ]
                    }, service.id);
                })
            })
        ]
    });
};
